<template>
  <footer
    class="w-full border-t border-gray-200 bg-white px-6 py-3 hidden md:flex items-center justify-between text-sm text-gray-500"
  >
    <span> © {{ currentYear }} BNG Hub. Todos os direitos reservados. </span>

    <div class="flex items-center gap-4">
      <button
        type="button"
        data-testid="app-version-button"
        class="hidden sm:inline-flex items-center gap-1.5 hover:text-primary transition-colors"
        @click="openPanel"
      >
        <span>Versão {{ appVersion }}</span>
        <span
          v-if="hasUnread"
          class="w-2 h-2 rounded-full bg-primary"
          aria-label="Novidades disponíveis"
        ></span>
      </button>
      <a
        href="https://minhaescala.app/privacy-policy.html"
        target="_blank"
        class="hover:text-primary transition-colors"
      >
        Privacidade
      </a>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useChangelog } from '@/hooks/useChangelog'
import packageJson from '../../package.json'

const currentYear = new Date().getFullYear()

const appVersion = packageJson.version

const { hasUnread, openPanel } = useChangelog()
</script>

<style scoped>
footer {
  min-height: 48px;
}
</style>
